import {isLoggedIn} from '@github-ui/client-env'
import {Navigate} from '@github-ui/react-router'
import {PageLayout} from '@primer/react'
import {ArtifactsContent} from '../components/artifacts/ArtifactsContent'
import {useIsFeatureStateEnabled} from '../hooks/use-feature-state'
import {useLayoutQuery} from '../page-data/loaders/use-layout-query'

export function ArtifactsEntrypoint() {
  const {pullRequest} = useLayoutQuery().data
  const artifactsEnabled = useIsFeatureStateEnabled('artifacts')

  if (!isLoggedIn() || !artifactsEnabled) {
    return <Navigate to={pullRequest.pathName} replace />
  }

  return (
    <PageLayout.Content as="div" width="full" padding="normal">
      <div id="artifacts-content" role="region" tabIndex={-1} aria-label="Artifacts">
        <ArtifactsContent />
      </div>
    </PageLayout.Content>
  )
}
